import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { omnitec_setCurrentOrganization } from '../../../../../actions/omnitecActions'
import {
    selectOrganizations,
    selectCurrentOrganization
} from '../../../../../selectors/omnitecSelectors/omnitecOrganizations'

import { selectEasymsOrganizationsKV } from '../../../../../selectors/easymsOrganizationSelector'

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 200,
        color: 'white'
    }
})

class CurrentOrganization extends Component {

    componentDidMount() {
        const currentOrg = localStorage.getItem('easyMs_ChannelManager_Omnitec_CurrentOrganization')
        if(currentOrg) this.props.onChangeOrganization(+currentOrg)
    }

    handleChange = e => {
        if (this.props.value !== e.target.value) {
            this.props.onChangeOrganization(e.target.value)
            localStorage.setItem('easyMs_ChannelManager_Omnitec_CurrentOrganization', e.target.value)
        }
    }

    render() {
        const { organizationList, value, classes, easymsOrganizationsKV } = this.props

        const orglist = easymsOrganizationsKV.filter(org => organizationList.map(item => item.ourId).includes(org.value))

        return (
            <form className={classes.root}>
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="organization-simple">Выберите организацию</InputLabel>
                    <Select
                        value={value}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'organization',
                            id: 'organization-simple'
                        }}
                    >
                        {orglist.map(org => (
                            <MenuItem key={org.value} value={org.value}>
                                {org.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </form>
        )
    }
}

CurrentOrganization.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    organizationList: PropTypes.array
}
CurrentOrganization.defaultProps = {
    value: ''
}

const mapStateToProps = state => ({
    value: selectCurrentOrganization(state),
    organizationList: selectOrganizations(state),
    easymsOrganizationsKV: selectEasymsOrganizationsKV(state)
})

const mapDispatchToProps = dispatch => ({
    onChangeOrganization: data => dispatch(omnitec_setCurrentOrganization(data))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CurrentOrganization))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/CurrentOrganization/CurrentOrganization.js